var map = {
	"./icon-agenda.png": 6621,
	"./icon-area-personale.png": 3592,
	"./icon-clima.png": 3609,
	"./icon-contacts.png": 2338,
	"./icon-curiosita.png": 6082,
	"./icon-day.png": 7651,
	"./icon-doc.png": 5559,
	"./icon-fuso.png": 5436,
	"./icon-info.png": 1325,
	"./icon-internet.png": 554,
	"./icon-night.png": 8423,
	"./icon-presa.png": 9634,
	"./icon-programma.png": 5311,
	"./icon-salute.png": 8265,
	"./icon-sicurezza.png": 1409,
	"./icon-tempo-libero.png": 5592,
	"./icon-valigia.png": 9630,
	"./icon-valuta.png": 2114,
	"./icon-varie.png": 1308
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5994;